<template>
    <div class="booking-client">
        <BookingCustomer
            v-model="customer"
            :errors="errors"
        />
        <h2>Trips</h2>
        <template
            v-for="trip, index in trips" 
            :key="trip.id"
        >
            <BookingTrip 
                v-model="trips[index]"
                :bookingService="bookingService"
                :tripIndex="index"
                :errors="errors?.trips && errors.trips.length > index ? errors.trips[index] : {}"
            >
                <template v-slot:header>
                    <a 
                        :key="trip.id"
                        href="#"
                        class="btn btn-harbour-blue" 
                        @click.prevent="deleteTrip(index, $event)">
                        Delete Trip
                    </a>
                </template>
                <template v-slot:footer>
                    <a href="#" class="btn btn-harbour-blue" @click.prevent="addReturnTrip(index)">Add Return</a>
                </template>
            </BookingTrip>
        </template>
        
        <div v-if="errors?.non_field_errors?.length > 0" class="booking-error">
            <p>There are some problems with your booking.</p>
            <ul>
                <li v-for="error, index in errors.non_field_errors" :key="index">{{ error }}</li>
            </ul>
        </div>
        <div class="booking-controls">
            <a href="#" class="btn btn-harbour-blue" @click.prevent="addNewTrip($event)">Add Trip</a>
            <a href="#" class="btn btn-harbour-blue" @click.prevent="bookTrip($event)">Book Now</a>
        </div>
    </div>
</template>

<script>
import BookingCustomer from '@/views/booking/BookingCustomer.vue';
import BookingTrip from '@/views/booking/BookingTrip.vue';
import PublicBookingService from '@/service/PublicBookingService.js';

export default {
    components: { BookingCustomer, BookingTrip },
    data() {
        return {
            bookingService: new PublicBookingService(),
            /* global stripe_pk */
            // eslint-disable-next-line no-unused-vars
            stripe: new window.Stripe(stripe_pk),
            newTripId: -2,
            customer: {
                first_name: '',
                last_name: '',
                telephone: '',
                email: '',
                email_confirm: '',
            },
            trips: [ this.newTrip(-1) ],
            errors: {}
        };
    },
    methods: {
        newTrip(id, prevPassengers = null) {
            return {
                id,
                booking_day: {
                    id: null,
                    date: null
                },
                start_location: null,
                end_location: null,
                route: {
                    route_id: null,
                    time_id: null,
                    time: null,
                    is_day: null
                },
                passengers: prevPassengers ? {...prevPassengers} : {
                    adults: 1,
                    children_under16: 0,
                    children_under1: 0,
                    dogs: 0,
                    bikes: 0
                }
            }
        },

        addNewTrip() {
            this.trips.push(this.newTrip(this.newTripId--));

            if (this?.errors?.trips) {
                this.errors.trips.push({});
            }
        },

        deleteTrip(index) {
            this.trips.splice(index, 1);

            if (this?.errors?.trips) {
                this.errors.trips.splice(index, 1);
            }
        },

        addReturnTrip(index) {
            let oldTrip = this.trips[index];
            let newTrip = this.newTrip(this.newTripId--, oldTrip.passengers);
            newTrip.end_location = oldTrip.start_location;
            newTrip.start_location = oldTrip.end_location;
            newTrip.booking_day.date = oldTrip.booking_day.date;

            this.trips.push(newTrip);
        },

        validateEmailConfirm() {
            if (this.customer.email.toLowerCase() !== this.customer.email_confirm.toLowerCase()) {
                if (!this?.errors) {
                    this.errors = {}
                }

                if (!this?.errors?.email_confirm) {
                    this.errors.email_confirm = [];
                }

                this.errors.email_confirm.push('The supplied email addresses do not match.');

                return false;
            }

            return true;
        },

        bookTrip() {
            this.errors = {};

            if (!this.validateEmailConfirm()) {
                return;
            }
            
            this.bookingService.checkBooking(this.customer, this.trips)
            .then(() => {
                this.bookingService.makeBooking(this.customer, this.trips)
                .then(data => {
                    this.stripe.redirectToCheckout({ sessionId: data.checkout_session });
                })
                .then(result => {
                    if (result.error) {
                        this.errors = result.error.message;
                    }
                })
                .catch(err => {
                    this.errors = err.response.data;
                });
            })
            .catch(err => {
                this.errors = err.response.data;
            });
        }
    }
}
</script>

<style lang="scss">
.booking-client {
    margin: 20px 0 40px;

    h3 {
        font-weight: bold;
        color: #14466E;
    }

    h4 {
        font-size: 1.2rem;
    }

    .booking-controls {
        display: flex;
        flex-direction: row;
        justify-content: center;

        a {
            margin: 0 10px;
        }
    }

    .booking-error {
        background-color: #ffd6d6;
        margin: 1em 0;
        padding: 1em;
        border-radius: 5px;

        ul {
            margin: 0;
        }
    }
}
</style>